<template>
  <div>
    <input v-model="time" class="w-full p-4 bg-gray-200" type="time" />
    <span class="text-red text-sm">{{ error }}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    serviceArea: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      error: ''
    }
  },
  computed: {
    time: {
      get () {
        return this.$store.getters['reservation/getTime']
      },
      set (value) {
        const date = this.$store.getters['reservation/getDate']
        const {
          operationStartTime,
          operationEndTime
        } = this.serviceArea.additional
        const timeFormat = /^([0-9]{2}):([0-9]{2})$/
        const t = timeFormat.test(value) ? value + ':00' : operationStartTime

        if (t < operationStartTime || t > operationEndTime) {
          this.error = this.$t('tour_alert_business_hours')
        } else {
          this.error = ''
        }
        this.$store.dispatch('reservation/updateDateTime', moment(date + ' ' + t))
      }
    }
  }
}
</script>
